<template>
 <canvas ref="myChart" width="100" height="30"></canvas>
</template>

<script>
import Chart from 'chart.js'
import _ from 'underscore'

export default {
    data () {
        return {
            chart: null
        }
    },
    props: {
        'matches': { type: Array, required: true },
        'matchesB': { type: Array },
        'userId': { type: Number, required: true },
        'userBId': { type: Number },
        'startTime': { type: Number },
        'endTime': { type: Number }
    },
    watch: {
        matches (oldVal, newVal) {
            this.render()
        },
        matchesB (oldVal, newVal) {
            this.render()
        }
    },
    created () {
        this.render()
    },
    methods: {
        render () {
            if (!this.$refs.myChart) {
                return
            }

            const endTime = this.endTime ? new Date(this.endTime) : new Date
            var startTime = this.startTime

            if (!startTime && this.matches.length > 0) {
                startTime = new Date(this.matches[this.matches.length - 1].updated_at + 'Z')
            }


            function prepareData(matches, userID) {
                if (!matches) {
                    return null
                }

                // Sort matches
                var mx = _.sortBy(matches, m => {
                    return m.created_at
                })

                mx = _.map(mx, m => {
                    return { 
                        x: new Date(m.created_at.replace(' ', 'T') + 'Z'),
                        y: m.player_a_id == userID ? m.elo_a : m.elo_b
                    }
                })

                // Add initial ELO at start
                if (matches.length > 0) {
                    const user = matches[0].player_a_id == userID ? 
                        matches[0].player_a : 
                        matches[0].player_b

                    mx.unshift({ x: new Date(user.created_at + 'Z'), y: 630 })

                    mx.push({
                        x: new Date(endTime-1),
                        y: mx[mx.length - 1].y 
                    })
                // Fill empty graph
                } else {
                    mx = [ { x: new Date(0), y: 630 },
                           { x: new Date, y: 630 } ]
                }

                return mx
            }

            const matches_a = prepareData(this.matches, this.userId)
            const matches_b = prepareData(this.matchesB, this.userBId)

            if (matches_a === null) {
                return
            }

            const datasets = [ {
                data: matches_a,
                borderColor: '#ff6666',
                backgroundColor: 'rgb(255, 159, 159)',
                pointBackgroundColor: '#ff6666',
                pointStyle: 'circle',
                borderWidth: 2,
                lineTension: 0,
                fill: 'origin'
            } ]

            if (matches_b !== null) {
                datasets.unshift({
                    data: matches_b,
                    borderColor: '#00265c',
                    backgroundColor: 'rgba(159, 199, 255, .7)',
                    pointBackgroundColor: '#00265c',
                    pointStyle: 'circle',
                    borderWidth: 2,
                    lineTension: 0,
                    fill: 'origin'
                })

                // Make sure last data point is at same x position (time)
                const last_a = _.last(matches_a)
                const last_b = _.last(matches_b)

                if (last_a.x < last_b.x) {
                    matches_a.push({
                        x: last_b.x,
                        y: last_a.y
                    })
                } else {
                    matches_b.push({
                        x: last_a.x,
                        y: last_b.y
                    })
                }
            }

            if (!this.chart) {
                // Build graph
                var ctx = this.$refs.myChart
                this.chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        datasets: datasets
                    },
                    options: {
                        legend: { display: false },
                        scales: {
                            xAxes: [{
                                id: 'x',
                                type: 'time',
                                display: false,
                                gridLines: { display: false },
                                time: {
                                    min: startTime,
                                    max: endTime
                                }
                            }],
                            yAxes: [{
                                id: 'y',
                                 ticks: {
                                    userCallback: function(label, index, labels) {
                                        // when the floored value is the same as the value we have a whole number
                                        if (Math.floor(label) === label) {
                                            return label
                                        }
                                    },
                                }
                            }],
                        }
                    }
                })
            } else {
                this.chart.data.datasets = datasets
                this.chart.update()
                this.chart.options.scales.xAxes['x'] = {
                    type: 'time',
                    display: false,
                    gridLines: { display: false },
                    time: {
                        min: startTime,
                        max: endTime
                    }
                }
                this.chart.update()
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// elo-chart.vue?4474489c